<template>
  <div>
    <el-form :inline="true" style="margin-left: 0; margin-bottom: 10px;">
      <el-form-item>
        <el-input
          @change="server"
          @input="server"
          v-model="searchStr"
          placeholder="请输入车牌"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="type === 'second'">
        <gateSelect
          ref="itemOut"
          @change="getItem"
          :selectKey="'Id'"
          :Direction="2"
          placeholder="出口车道"
          v-model="outGateId"
          :isDisabled="false"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          @change="server"
          @input="server"
          v-model="secondaryConfirmRemark"
          placeholder="二次确认备注"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="server">
          <img src="@/assets/img/icon03.png" style="width: 14px; margin-right: 5px;"/>
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      height="400"
    >
      <el-table-column align="center" label="序号" type="index" width="50" :index="indexMethod">
      </el-table-column>
      <el-table-column
        align="center"
        prop="plateNumber"
        label="车牌"
        width="100"
      >
      </el-table-column>
      <el-table-column align="center" label="车类">
        <template slot-scope="scope">
<!--          <span>{{scope.row.isBillPack * 1 === 1 ? '包期车' : scope.row.carTypeStr}}</span>-->
          <span>{{scope.row.carTypeStr}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="cameAt"
        label="入场时间"
        width="170"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="paidAt"
        label="最后缴费时间"
        width="170"
      >
      </el-table-column>
      <el-table-column align="center" prop="entranceName" label="入场车道">
      </el-table-column>
      <el-table-column align="center" prop="exitName" label="出场车道">
      </el-table-column>
      <!-- <el-table-column align="center" prop="allMoney" label="入场操作员">
      </el-table-column> -->
      <el-table-column align="center" prop="remark" label="备注">
      </el-table-column>
      <el-table-column align="center" prop="secondaryConfirmRemark" label="二次确认备注" width="150px">
      </el-table-column>
      <el-table-column align="center" prop="remark" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleLookup(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page-size ref="page" @pageChange="server" />
    <!-- 查看详情 -->
    <dialog-query-order v-if="detailDialogFormVisible" :showdialog.sync="detailDialogFormVisible" :orderId="tempOrder.id"></dialog-query-order>
  </div>
</template>

<script>
import { queryParkOrder } from "@/api/module/tenant";
import PageSize from "@/components/PageSize";
import parkMix from "@/minxs/parkLotId";
import dialogQueryOrder from "@/serviceComponents/dialogQueryOrder";
import gateSelect from "@/serviceComponents/gateSelect";

export default {
  data: () => ({
    activeType: '',
    searchStr: "",
    secondaryConfirmRemark: undefined,
    tempOrder: {},
    detailDialogFormVisible: false,
    plateColorOptions: ['未知', '蓝色', '黄色', '白色', '黑色', '绿色', '新能源'],
    carSizeTable: [],
    tableData: [],
    loading: false,
    outGateId: '',
  }),
  props: { type: String },
  mixins: [parkMix],
  watch: {
    type: function() {
      const $page = this.$refs.page;
      $page.current = 1;
      $page.pageSize = 20;
      this.server();
    },
  },
  mounted() {
    this.server();
  },
  computed: {
    carSize: function () {
      let arr = this.carSizeTable.filter(v => {
        return v.Id === this.tempOrder.carSize
      });
      if (arr.length === 0) arr[0]= {Name: '不区分'};
      return arr[0].Name
    }
  },
  methods: {
    indexMethod(index) {
      const $page = this.$refs.page;
      return index + ($page.current - 1) * $page.pageSize + 1
    },
    async server() {
      this.loading = true;
      const $page = this.$refs.page;
      let res = await queryParkOrder({
        Page: $page.current,
        PerPage: $page.pageSize,
        ParkLotId: this.ParkLotId,
        orderNo: "",
        PlateNumber: this.searchStr,
        OutGateId: this.outGateId,
        SecondaryConfirmRemark: this.secondaryConfirmRemark,
        orderType: this.type === "first" ? "正常" : "全部",
        IsLimitDate: 1,
        Isleft: this.type === "first" ? 2 : 1,
        GateQuery: true,
      });
      this.loading = false;
      if (res.state === "success") {
        let data = res.data;
        // data.forEach((item) => {
        //   item.isEdit = false;
        //   item.editNumber = "";
        // });
        this.tableData = data;
        $page.total = res.pageInfo.Total;
      } else {
        this.tableData = [];
        $page.total = 0;
      }
    },
    // 查看详情
    handleLookup(row) {
      this.tempOrder.id = row.id;
      this.detailDialogFormVisible = true;
    },
    getItem(item) {
      // this.$store.dispatch("SetPubOutGateId", item.Id);
      if(item) {
        this.outGateId = item.Id;
        this.server()
      }
    },

  },
  components: {
    PageSize,
    dialogQueryOrder,
    gateSelect,
  },
};
</script>

<style lang="scss" scoped>
.info {
  margin: 20px 0;
  h2 {
    margin: 12px 0;
  }
  p {
    margin: 5px 0;
    span {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin: 0 15px;
    }
  }
}
.img-list{
  span {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin: 0 15px;
  }
}
.single-img{
  margin: 10px 130px;
  width: 130px;
  height: 82px;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
